import React, { useState } from 'react'
import Loading from 'src/Common/ui/Loading'
import TcRACI from '../TcRACI'
import { useForm } from 'react-hook-form'

export default function ReRaci ({ matrixOptions, setMatrixOptions }) {
    const [ loading, setLoading ] = useState(false)
    const { formState: { errors }, control } = useForm({})
    const setTransferTableSearchValue = () => {
        return ''
    }
    return (
        <>
            <Loading isLoading={loading} setLoading={setLoading}/>
            <TcRACI
                errors={errors}
                control={control}
                loading={loading}
                setLoading={setLoading}
                matrixOptions= {matrixOptions}
                setMatrixOptions={setMatrixOptions}
                setTransferTableSearchValue={setTransferTableSearchValue}
                resetShow={false}
                disableDep={!!matrixOptions?.department}
            />

        </>
    )
}
